module.exports = __webpack_public_path__ + "static/img/son2.445c56bc.png";